import { Component, Vue, Watch } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'
let fuse = new Fuse([], {})

library.add(faTrashAlt, faEdit)

@Component({
	components: {
		Loader,
	},
})
export default class SituationsAdm extends Vue {
	loading = false
	modalLoading = false
	options = [] as Array<any>
	filter = ''

	form = {
		id: '',
		name: '',
	}

	get filteredOptions() {
		// @ts-ignore
		return this.filter.length
			? fuse.search(this.filter).map(({ item }) => item)
			: this.options
	}

	async init() {
		this.options.length = 0

		this.loading = true
		const res = await api.get('/api/situations-adm')
		this.loading = false
		this.options.length = 0
		this.options.push(
			...res.data.map((option) => {
				const hasTrial = option.trialsAdms_aggregate.aggregate.count > 0
				Object.assign(option, { loading: false, hasTrial: hasTrial })
				return option
			}),
		)
		// @ts-ignore
		fuse = new Fuse(this.options, {
			keys: ['name'],
		})
	}

	clearForm() {
		this.form.id = ''
		this.form.name = ''
		this.modalLoading = false
	}

	openEdit(situation) {
		this.form.id = situation.id
		this.form.name = situation.name
		this.$bvModal.show('modal-edit-situation')
	}

	openNew() {
		this.clearForm()
		this.$bvModal.show('modal-new-situation')
	}

	async saveEdit() {
		if (!this.form.name) {
			this.$bvToast.toast(`O campo 'nome' é obrigatório!`, {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			try {
				this.modalLoading = true
				const situation = this.options.find(
					(situation) => situation.id === this.form.id,
				)

				const res = await api.put(
					'/api/situations-adm/' + situation.id,
					this.form,
				)
				if (res.ok) {
					situation.name = this.form.name
					this.$bvModal.hide('modal-edit-situation')
					this.$bvToast.toast('Situação salva com sucesso!', {
						title: 'Sucesso!',
						autoHideDelay: 2500,
						appendToast: true,
						variant: 'success',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				} else {
					this.$bvToast.toast('Ocorreu um erro inesperado!', {
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				}
			} catch (error) {
				this.$bvToast.toast(
					'Ocorreu um erro ao processar a requisição!',
					{
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					},
				)
			} finally {
				this.modalLoading = false
			}
		}
	}

	async saveNew() {
		if (!this.form.name) {
			this.$bvToast.toast(`O campo 'nome' é obrigatório!`, {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			try {
				this.modalLoading = true
				const res = await api.post('/api/situations-adm/', this.form)
				if (res.ok) {
					this.options.push({
						id: res.id,
						name: this.form.name,
						loading: false,
					})

					// @ts-ignore
					fuse = new Fuse(this.options, {
						keys: ['name'],
					})

					this.$bvModal.hide('modal-new-situation')
					this.$bvToast.toast('Situação adicionada com sucesso!', {
						title: 'Sucesso!',
						autoHideDelay: 2500,
						appendToast: true,
						variant: 'success',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				} else {
					this.$bvToast.toast('Ocorreu um erro inesperado!', {
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				}
			} catch (error) {
				this.$bvToast.toast(
					'Ocorreu um erro ao processar a requisição!',
					{
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					},
				)
			} finally {
				this.modalLoading = false
			}
		}
	}

	async deleteSituation(situation, index) {
		const res = await api.delete('/api/situations-adm/', situation)
		if (res.ok) {
			this.options.splice(index, 1)
			this.filter = this.filter.length ? '' : this.filter
			this.$bvToast.toast(
				'Situação excluída com sucesso!',
				{
					title: 'Sucesso!',
					autoHideDelay: 2500,
					appendToast: true,
					variant: 'success',
					toaster: 'b-toaster-top-center',
					solid: true,
				},
			)
		} else {
			this.$bvToast.toast('Ocorreu um erro inesperado!', {
				title: 'Erro!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'danger',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		}
	}

	mounted() {
		this.init()
	}
}
